export const BaseSelect = ({ value, onChange, children, style, ...rest }) => {
  return (
    <select
      value={value}
      onChange={onChange}
      style={{
        width: "100%",
        padding: "12px 15px",
        borderRadius: 8,
        border: "1px solid #ccc",
        fontSize: 16,
        ...style,
      }}
      {...rest}
    >
      {children}
    </select>
  );
};

export default BaseSelect;